import { IObjectAudit, INoteType, IDate, ITimecard, IObjectTimecardDocument } from "../../models"

export interface INoteDocument {
    Id: string
    AccountId: string
    ObjectId: string
    ObjectType: ENoteObjectType
    AuditType: EAuditType
    ObjectAudit: IObjectAudit
    ObjectName: string
    Title: string
    Note: string
    NoteType: INoteType
    IsNote: boolean
    IsAudit: boolean
    ReadOnly: boolean
    Deleted: boolean
    TicksSinceChange: number
    ExternalId: string
    ReferenceDate: IDate
    MessageInfo: IMessageInfo
    TimecardRef: INoteTimecardRef
    SubscriberEmailList: string
    FormData: string
}

export interface INoteTimecardRef {
    UserId: string
    StartDate: IDate
    Timecard: IObjectTimecardDocument
}

export interface IMessageInfo {
    IsMessage: boolean
    IsMessageSentByOwner: boolean
    MessageType: EMessageType
    MessageSenderUserId: string
    MessageSenderName: string
    Reviewed: boolean
    ReviewedBy: string
    ReviewedByName: string
}

export enum EMessageType {
    SMS = 0,
    Email = 1,
    PushNotification = 2,
    App = 3
}

export enum ENoteObjectType {
    User = 0,
    Client = 1,
    Contact = 2,
    Job = 3,
    Other = 4 //Don't need to specify since we are using GUIDs. We can simply query by "ObjectId" and get back object notes.
}

export enum EAuditType {
    General = 0,
    Email = 1,
    SMS = 2,
    StatusChange = 3,
    PropertyChange = 4
}


export interface INoteContext {
    ReferenceObjectType: ENoteObjectType
    ReferenceObjectId: string
    ReferenceObjectName: string
    ReferenceClientName: string
    ReferenceClientId: string
}